"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersSubmitPreview = void 0;
// import { TableCell } from '@material-ui/core';
const core_1 = require("@material-ui/core");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const paper_1 = require("client/components/material/paper");
const router_1 = require("client/components/router");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/store");
const store_3 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
const button_1 = require("../../../../components/material/button");
require("./orders-submit-preview.less");
const us_states_1 = require("../../../../modules/constant/us-states"); //B-038.3
let OrdersSubmitPreview = class OrdersSubmitPreview extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showConfirmationModal = false;
        this.loadingSaving = false;
        this.ordersToPersist = [];
        this.ordersToPersistArray = [];
        this.schedules = [];
        this.shouldPromptForRemap = false;
        this.listOfState = us_states_1.GLOBAL_PROVINVCE; //B-038.3 
        this.genderObj = {
            male: "Male",
            m: "Male",
            man: "Male",
            f: "Female",
            female: "Female",
            woman: "Female"
        };
        this.handleAutoSubmit = () => {
            store_1.ordersStore.shouldAutomateSubmission = false;
            store_1.ordersStore.submitAutomation = false;
            store_1.ordersStore.fileFormat = null;
            this.handleSubmitReview();
        };
        this.checkValidAppointmentDate = () => {
            console.info("checkValidAppointmentDate triggered");
            const truncatedSchedules = this.ordersToPersist.slice(0, 10);
            for (const schedule of truncatedSchedules) {
                if (!this.isValidAppointmentDate(schedule.DATE)) {
                    console.info(`Invalid appointmentDate detected; Patient: ${schedule.PATIENT_FIRST_NAME} ${schedule.PATIENT_LAST_NAME} Appointment Date: ${schedule.DATE} is not within the valid range.`, schedule);
                    this.shouldPromptForRemap = true;
                    break;
                }
            }
        };
        this.isValidAppointmentDate = (apptDate) => {
            const oneMonthAgo = moment().subtract(1, "month");
            const oneYearFromNow = moment().add(1, "year");
            const appointmentDate = moment(apptDate);
            return moment(appointmentDate).isBetween(oneMonthAgo, oneYearFromNow);
        };
        this.handleOnConfirmation = () => {
            this.showConfirmationModal = true;
        };
        this.handleSubmitReview = async () => {
            this.showConfirmationModal = false;
            this.loadingSaving = true;
            const { siteId } = store_1.ordersStore.importedFileAndSiteId;
            // action log schedule map data.
            try {
                let scheduleName = "";
                if (store_1.ordersStore.importedFileAndSiteId &&
                    store_1.ordersStore.importedFileAndSiteId.accepted) {
                    for (const file of store_1.ordersStore.importedFileAndSiteId.accepted) {
                        if (scheduleName === "") {
                            scheduleName += file.name;
                        }
                        else if (scheduleName !== "" &&
                            typeof scheduleName === "string" &&
                            scheduleName.length) {
                            scheduleName += ` ${file.name}`;
                        }
                    }
                }
                let actionMessage = `Schedule Name: ${scheduleName}
       Schedule Column Map:
       `;
                for (const key in this.mappedHeadersObject) {
                    if (this.mappedHeadersObject.hasOwnProperty(key)) {
                        if (this.mappedHeadersObject[key]) {
                            actionMessage += `${this.mappedHeadersObject[key]} -> ${key}
            `;
                        }
                    }
                }
                const logData = {
                    user: store_3.usersStore.user.value.id,
                    action: actionMessage,
                    category: store_3.LogCategory.schedule,
                    categoryReferenceKey: null,
                    site: Number(siteId),
                    order: null
                };
                store_2.auditLoggerStore.auditLog(logData);
            }
            catch (err) {
                console.error("Error audit logging schedule map data", err);
            }
            store_1.ordersStore.patientSchedulesAndSite = {
                patientSchedules: this.ordersToPersistArray,
                siteId: Number(siteId)
            };
            try {
                await store_1.ordersStore.parseMappedSchedule(this.ordersToPersistArray, siteId.toString(), null, null, store_1.ordersStore.selectedProviderId);
            }
            catch (e) {
                console.error("errror isn parsemappedSchedule ----", e);
            }
            finally {
                this.loadingSaving = false;
                router_1.RouteManager.transitionTo("/claims/submit");
            }
        };
        this.handleOnCancel = () => {
            // console.log('handleOnCancel triggered');
        };
        this.renderTableRow = (row, i) => (React.createElement(core_1.TableRow, { className: `select-header-table__row`, key: i }, row.map((cell, i) => (React.createElement(core_1.TableCell, { className: "select-header-table__row--cell", key: i }, cell)))));
        // @tkay 11/19/2018 filter out patient_full_name
        this.renderPreview = () => this.ordersToPersistArray.map((row, i) => this.renderTableRow(row, i));
    }
    componentWillReceiveProps() {
        // console.log('cwrp triggered');
    }
    componentWillUnmount() {
        if (store_1.ordersStore.submitAutomation) {
            store_1.ordersStore.shouldAutomateSubmission = false;
            store_1.ordersStore.submitAutomation = false;
        }
    }
    componentWillMount() {
        if (!store_1.ordersStore.importedOrders || !store_1.ordersStore.importedOrders.length) {
            router_1.RouteManager.transitionTo("/claims/submit");
        }
        this.mappedHeadersObject = store_1.ordersStore.mappedHeadersObject || {};
    }
    /**
     * convert/map parsedRows data to an array of schedule objects to be persisted.
     */
    componentDidMount() {
        var _a;
        const importedOrders = store_1.ordersStore.importedOrders;
        // console.log("importedOrders is ", importedOrders);
        this.ordersToPersist = importedOrders
            ? importedOrders.map((order) => {
                const newOrder = {};
                store_1.ordersStore.dbHeaders.forEach(key => {
                    newOrder[key] = this.mappedHeadersObject[key]
                        ? order[this.mappedHeadersObject[key]]
                        : "";
                });
                return newOrder;
            })
            : [];
        // B-038.3 listOfState
        (_a = this.ordersToPersist) === null || _a === void 0 ? void 0 : _a.map((item) => {
            if (item.PATIENT_STATE) {
                item.PATIENT_STATE = item.PATIENT_STATE.toLowerCase();
                if (this.listOfState[item.PATIENT_STATE]) {
                    item.PATIENT_STATE = this.listOfState[item.PATIENT_STATE];
                }
                else {
                    item.PATIENT_STATE = item.PATIENT_STATE.toUpperCase();
                }
            }
            if (item.PATIENT_GENDER) {
                item.PATIENT_GENDER = item.PATIENT_GENDER.toLowerCase();
                if (this.genderObj[item.PATIENT_GENDER]) {
                    item.PATIENT_GENDER = this.genderObj[item.PATIENT_GENDER];
                }
                else {
                    item.PATIENT_GENDER = item.PATIENT_GENDER;
                }
            }
            // if (item.PATIENT_DOB) {
            //   item.PATIENT_DOB = item.PATIENT_DOB
            //     ? moment(item.PATIENT_DOB).format("YYYY-MM-DD") // by using this getting error on DOB format
            //     : null;
            // }
        });
        // @tkay logic to set first and last names if full name was provided.
        this.ordersToPersist = store_1.ordersStore
            .fillInMissingData(this.ordersToPersist)
            .filter((order) => {
            // Check the first name for special characters except for a single quote, a space (double first name) and hyphen and we take off the nickname
            order.PATIENT_FIRST_NAME = order.PATIENT_FIRST_NAME.split(/[^A-Za-z-\' ]/)[0];
            const firstName = order.PATIENT_FIRST_NAME || "";
            const lastName = order.PATIENT_LAST_NAME || "";
            const nameIsNotTotal = firstName.toLowerCase() !== "total" &&
                lastName.toLowerCase() !== "total";
            return firstName && lastName && nameIsNotTotal;
        });
        this.checkValidAppointmentDate();
        // reset scheduleDateFromRtf in ordersStore
        store_1.ordersStore.scheduleDateFromRtf = "";
        const orderRowsArray = this.ordersToPersist.map((order) => {
            const data = [];
            for (const prop in order) {
                if (prop !== "PATIENT_FULL_NAME" &&
                    prop !== "DATE_TIME" &&
                    prop !== "PROVIDER_FULL_NAME") {
                    // @tkay omit PATIENT_FULL_NAME COLUMN preview
                    data.push(order[prop]);
                }
            }
            return data;
        });
        // prepend header
        const headers = [];
        for (const prop in this.ordersToPersist[0]) {
            if (prop !== "PATIENT_FULL_NAME" &&
                prop !== "DATE_TIME" &&
                prop !== "PROVIDER_FULL_NAME") {
                // @tkay omit DATE_TIME
                headers.push(prop);
            }
        }
        orderRowsArray.unshift(headers);
        this.ordersToPersistArray = orderRowsArray;
        // AUTO SUBMIT
        if (store_1.ordersStore.submitAutomation && !this.shouldPromptForRemap) {
            this.handleAutoSubmit();
        }
    }
    render() {
        const loadingClass = this.loadingSaving
            ? " ui-dropzone__loading-bg--loading"
            : "";
        return (React.createElement("div", { className: "orders-submit-preview" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement(kpi_title_1.KpiTitle, { label: "Import Preview", subLabel: "" })),
            React.createElement(paper_1.MaterialPaper, { className: "orders-submit-preview__header-preview" },
                React.createElement("div", { className: "header-paper__message" },
                    React.createElement("h3", null, "Please review the data"),
                    React.createElement("div", null,
                        React.createElement(button_1.MaterialButton, { onClick: this.handleOnCancel, to: "/claims/submit/map" }, "Back"),
                        React.createElement(button_1.MaterialButton, { disabled: this.loadingSaving || !this.ordersToPersist.length, primary: true, onClick: this.handleOnConfirmation }, "confirm"))),
                this.ordersToPersist && (React.createElement("div", { className: "table-indicator-container" },
                    React.createElement(core_1.Table, { className: "select-header-table" },
                        React.createElement(core_1.TableBody, null, this.ordersToPersist && this.renderPreview())),
                    !this.ordersToPersist.length ? (React.createElement("div", null, "No valid patients from mapping. Patient first and last names are required. Please ensure patient names are mapped correctly.")) : null,
                    this.loadingSaving && (React.createElement("div", { className: `orders-submit-preview__header-preview__loading-bg${loadingClass}` },
                        React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "orders-submit-preview__header-preview__loading-indicator" })))))),
            this.showConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Submit", cancelText: "Back to review", message: `Please review the mapped table. If you are satisfied with the mapping, please submit.`, onCancel: () => (this.showConfirmationModal = false), onConfirm: this.handleSubmitReview, title: "Review confirmation" })),
            this.shouldPromptForRemap && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Proceed", cancelText: "Remap", message: `Invalid appointment date detected. Proceed to continue with the schedule drop. Remap to attempt to fix the data mapping.`, onCancel: () => router_1.RouteManager.transitionTo("/claims/submit/map"), onConfirm: this.handleAutoSubmit, title: "Review confirmation" }))));
    }
};
__decorate([
    mobx_1.observable
], OrdersSubmitPreview.prototype, "showConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitPreview.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitPreview.prototype, "mappedHeadersObject", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitPreview.prototype, "ordersToPersist", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitPreview.prototype, "ordersToPersistArray", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitPreview.prototype, "schedules", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitPreview.prototype, "shouldPromptForRemap", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitPreview.prototype, "listOfState", void 0);
OrdersSubmitPreview = __decorate([
    mobx_react_1.observer
], OrdersSubmitPreview);
exports.OrdersSubmitPreview = OrdersSubmitPreview;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-submit-preview/orders-submit-preview.tsx
// module id = 3789
// module chunks = 0